import type { ErrorLog } from "../../types";

interface Props {
  error: ErrorLog;
}

const dotColors: Record<string, string> = {
  grammar: "bg-warning",
  vocabulary: "bg-terracotta",
  syntax: "bg-success",
  default: "bg-error",
};

export default function ErrorItem({ error }: Props) {
  const dot = dotColors[error.error_type] || dotColors.default;
  return (
    <div className="bg-surface2 border border-border-soft rounded-[10px] px-3.5 py-3 text-xs animate-fade-in">
      <div className="flex items-center gap-1.5 mb-1.5">
        <span className={`w-1.5 h-1.5 rounded-full ${dot}`} />
        <span className="text-[0.625rem] uppercase tracking-[0.12em] font-semibold text-text-secondary">
          {error.error_type}
        </span>
      </div>
      <div className="text-error line-through decoration-error/50">{error.original_text}</div>
      <div className="text-success font-medium">{error.corrected_text}</div>
      <div className="text-text-secondary mt-1.5 italic text-xs leading-relaxed">{error.explanation}</div>
    </div>
  );
}
